import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { MultiSub } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MultiSubService {

  constructor(private http: HttpClient) { }

  getAll(filter: any): Observable<BaseResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/report/multi-sub/graph`, filter)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/multi-sub/export`, filter);
  }

}
